import React, { FC } from 'react';
import cls from 'classnames';
import { SmoothStarIcon } from '../../../../atoms/Icons';
import { numberWithThousands } from '../../../../../utils/commons';

interface CustomerRatingBarProps {
  className?: string;
  size?: 'regular' | 'medium' | 'large';
  type?: string;
  slug?: string;
  rating: number;
  ratingCount: number;
}

const CustomerRatingBar: FC<CustomerRatingBarProps> = ({
  ratingCount = 0,
  rating = 0,
  size = 'regular',
  className = '',
  type,
  slug,
}) => {
  const hasRating = !!ratingCount;
  const hasModelData = type && slug;

  return (
    <div className={cls('customer-rating-bar', className)}>
      <div className={cls('customer-rating-bar__bar', size)}>
        <div className="customer-rating-bar__bar__fill" style={{ width: `${rating}%` }} />
      </div>
      <div className="customer-rating-bar__score">
        <SmoothStarIcon color="#6E90C5" />
        <span>{Math.round(rating)}</span>
      </div>
      <div className="customer-rating-bar__text">
        {hasRating || (!hasRating && !hasModelData)
          ? `Based on ${numberWithThousands(ratingCount, 5)} rating${ratingCount === 1 ? '' : 's'}`
          : null}

        {!hasRating && type && slug ? (
          <a className="link has-link" href={`/review-mattress/${type}/${slug}`} rel="noreferrer" target="_blank">
            Write a review
          </a>
        ) : null}
      </div>
    </div>
  );
};

export default CustomerRatingBar;
